module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAAhElEQVQokbWRwQ3CMBAExxFN8KMP3EDqgMLjB0m6GD6xOCJZ2A9WOunk83r31qizujqGVZ2TugJXxrERXssqHZUrIZJRlx92S+Qk1cNGGrAswHQ6XI5Bq0q8/HflQgOX0Gfg1qF6r03rn+sK0sY+AU9g71CMeAGP9MnrS6krvHNgI4nzBprVz2flqtaxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/routeDetail-btn2.png
// module id = qmPa
// module chunks = 1